<template>
  <div class="login-page">
    <div class="login-content">
      <div class="login-brand">
        <img src="../assets/ST_logo_onwhite.png" alt="Sea Tow" class="login-logo" />
        <div class="login-divider"></div>
        <span class="login-app-name">Membership Portal</span>
      </div>

      <div class="login-card">
        <h1 class="login-heading">Welcome back</h1>
        <button class="login-btn" @click="doLogin">
          <img src="../assets/mssymbol.svg" alt="Microsoft" class="login-btn-icon" />
          Continue with Microsoft
        </button>

        <div v-if="error" class="login-error">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor" class="login-error-icon">
            <path d="M8 1a7 7 0 100 14A7 7 0 008 1zm-.75 3.75a.75.75 0 011.5 0v4a.75.75 0 01-1.5 0v-4zm.75 7a.75.75 0 110-1.5.75.75 0 010 1.5z"/>
          </svg>
          {{ error }}
        </div>
      </div>

      <p class="login-hint">
        Requires an <strong>@seatow.com</strong> account
      </p>
    </div>

    <footer class="login-footer">
      &copy; {{ new Date().getFullYear() }} Sea Tow Services International
    </footer>
  </div>
</template>

<script>
import auth from "../services/auth";
import { trackUxcamEvent } from "../services/uxcam";

export default {
  data: function () {
    return {
      error: "",
    };
  },
  methods: {
    async doLogin() {
      trackUxcamEvent("login_started");
      try {
        await auth.login();
        this.user = auth.user();
        this.$emit("loginComplete");
      } catch (err) {
        this.error = err.toString();
        trackUxcamEvent("login_failed", { message: err.toString() });
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--bg-page);
  padding: 1.5rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.login-content {
  width: 100%;
  max-width: 400px;
}

/* Brand bar */
.login-brand {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 2rem;
}

.login-logo {
  height: 32px;
  width: auto;
}

.login-divider {
  width: 1px;
  height: 24px;
  background: var(--border-input);
}

.login-app-name {
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text-muted);
  letter-spacing: 0.01em;
}

/* Card */
.login-card {
  background: var(--bg-surface);
  border: 1px solid var(--border-default);
  border-radius: 12px;
  padding: 2.5rem 2rem;
}

.login-heading {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 1.5rem;
  letter-spacing: -0.025em;
}

/* Button */
.login-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 12px 20px;
  font-size: 0.925rem;
  font-weight: 600;
  color: var(--accent-text);
  background: var(--accent);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s ease, box-shadow 0.15s ease;
}

.login-btn:hover {
  background: var(--accent-hover);
  box-shadow: 0 1px 4px var(--shadow-lg);
}

.login-btn:active {
  background: var(--accent-active);
}

.login-btn-icon {
  width: 18px;
  height: 18px;
}

/* Hint */
.login-hint {
  font-size: 0.78rem;
  color: var(--text-faint);
  margin-top: 1rem;
  text-align: center;
}

.login-hint strong {
  color: var(--text-muted);
  font-weight: 600;
}

/* Error */
.login-error {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 1.25rem;
  padding: 12px 14px;
  background: var(--error-bg);
  border: 1px solid var(--error-border);
  border-radius: 8px;
  color: var(--error-text);
  font-size: 0.82rem;
  line-height: 1.5;
}

.login-error-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

/* Footer */
.login-footer {
  margin-top: 3rem;
  font-size: 0.75rem;
  color: var(--text-faint);
}
</style>
